export enum KeeValueSubscriptionStatus {
  NOT_CONNECTED = 'NOT_CONNECTED',
  VALID = 'VALID',
  INVALID = 'INVALID',
  MISSING_MODULE = 'MISSING_MODULE',
}
